
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuPancakePopularPancakeLunchImage } from "@src/constants/images";
import { meta as rainbowPancakePageMeta } from "./rainbow_pancake.mdx";
import { meta as uzunaomomPageMeta } from "./uzunaomom.mdx";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
export const meta = {
  path: "/media/harajuku/pancake_popular",
  title: "【原宿】行列のできる人気パンケーキランチ４選！",
  description: "パンケーキやランチの激戦区原宿でいつも行列を作るほど人気のお店を4つご紹介させていただきます。ランチに合うお食事系から甘いパンケーキまで人気のメニューを厳選してご紹介。行列情報や狙い目の時間帯も併せてご紹介しますので、原宿ランチでパンケーキが食べたい方におすすめの記事です。",
  topImg: harajukuPancakePopularPancakeLunchImage,
  author: murakamiMasanori,
  tags: ["原宿", "パンケーキ", "人気店", "まとめ記事", "1人メシ", "デート", "女子会"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`パンケーキやランチの激戦区原宿でいつも行列を作るほど人気のお店を 4 つご紹介させていただきます。`}</p>
    <p>{`定番の人気パンケーキ店から、ランチメニューが豊富な大人なカフェまで、その日のニーズに併せたお店を見つけることができます。`}</p>
    <p>{`お食事系から甘いパンケーキまで、人気のメニューを厳選して写真付きでご紹介。行列情報や狙い目の時間帯も併せてご紹介しますので、原宿ランチでパンケーキが食べたい方におすすめの記事です。`}</p>
    <h2>{`レインボーパンケーキ`}</h2>
    <InstaImage postId="BlhOfjbgiIn" mdxType="InstaImage" />
    <p>{`パンケーキ激戦区の原宿でいつも上位にランクインする原宿の人気パンケーキ店。
ハワイをコンセプトにしたお店で、食べログの評価も高い。
レインボーパンケーキの名前の通り、インスタグラムでも色とりどりのパンケーキを見ることができます。`}</p>
    <h3>{`ランチタイムは行列`}</h3>
    <p>{`原宿はランチの激戦区ですが、ランチにかかわらず開店前から行列ができることもあるほどで、特に 11 時から 14 時ランチタイムでは、ランチセットでパンケーキがお得に食べられることがまた行列を作っています。`}</p>
    <p>{`行列を避けて行きたい方は、早めの時間帯か時間指定で予約ができるのでランチでも予約をしていくことをお勧めします`}</p>
    <h4>{`サーモン＆アボカド`}</h4>
    <InstaImage postId="BYVXmo_B0y3" mdxType="InstaImage" />
    <p>{`お食事系パンケーキの王道メニュー。もちもち食感の甘いパンケーキに、サーモンとアボカドを一緒に口に運ぶと、さっぱりとしたフレッシュさと甘味が口の中に広がります。ランチメニューとしてもボリューム感のあるメニューです。`}</p>
    <LinkWithThumbnail meta={rainbowPancakePageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="bqqe7ui23akg00avmn3g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`エッグスシングス`}</h2>
    <InstaImage postId="B7hcWuVnwV6" mdxType="InstaImage" />
    <p>{`ハワイ発祥の人気パンケーキ店で、日本にパンケーキを広めた代表的な存在。日本全国に店舗があるので、一度は聞いたこともある方も多いのではないでしょうか。原宿にも店舗があり、パンケーキやワッフルをはじめとしたスイーツメニューから、エッグベネディクトやトーストなどのメニューまで幅広く食べることができます。`}</p>
    <h3>{`ランチ時間以外も行列`}</h3>
    <p>{`原宿の中でも人通りが多いエリアに位置するので、いつも大行列ができていいます。筆者が調査しに行ったところコロナの影響で緊急事態宣言が明けたばかりの時期でも、昼の 13 時頃で 20 人弱の列が並んでいました。
行列を避けるためには、ランチでも早めの時間帯を狙わないと、ランチでもかなりの時間帯並ばないといけなくなります。`}</p>
    <p>{`パンケーキ激戦区と呼ばれる原宿でも 1 番行列が並んでいるのではないでしょうか。`}</p>
    <p>{`###　メニューが豊富`}</p>
    <InstaImage postId="Bp4Y5RagnDX" mdxType="InstaImage" />
    <InstaImage postId="BpmaChYHdHh" mdxType="InstaImage" />
    <p>{`定番のホイップクリームがタワーになっているパンケーキから、エッグベネディクトなどまで、いろんな種類のハワイアンメニューのランチが楽しめることが行列のできる人気の理由の１つだと思います。
その日の気分に合わせてパンケーキやその他のランチメニューを選んでみてください！`}</p>
    <ShopInfoBox shopId="brag25i23akg00evu3e0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ウズナオムオム`}</h2>
    <InstaImage postId="BsXA8poA5ay" mdxType="InstaImage" />
    <p>{`行列ができる原宿パンケーキの中でも、穴場的な存在として有名なお店がウズナオムオム。食べログの評価も高いお店で、インスタグラムでたくさんのおしゃれパンケーキパンケーキやランチメニューを確認することができます。`}</p>
    <h3>{`行列ができにくい穴場店`}</h3>
    <p>{`原宿のパンケーキの名店といえば、行列に並ばないと食べられないイメージが強いですが、ウズナオムオムでは行列に並ばずに食べられることができるので隠れファンがたくさんいます。`}</p>
    <p>{`マンションの二階にあるアットホームなお店なので、最初は場所がわからなかったり、入り口にびっくりするかもしれませんが、ランチでもティータイムでも訪れる価値があるお店です。`}</p>
    <h3>{`生ハムとクリームチーズ`}</h3>
    <InstaImage postId="B88w7JiAEwK" mdxType="InstaImage" />
    <p>{`塩気のあるプロシュートと甘いクリームチーズがトッピングされたもちもちのパンケーキメニュー。このようなお食事系のパンケーキのメニューだけでなく、カレーやランチプレートなども幅広く揃っているので、パンケーキもランチもどちらも食べてみたいという方にはおすすめです！`}</p>
    <LinkWithThumbnail meta={uzunaomomPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brd4mqq23akg009mvap0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ミカサデコ＆カフェ`}</h2>
    <InstaImage postId="B-iuPpJg3G4" mdxType="InstaImage" />
    <p>{`裏原に位置する隠れ家的なカフェで、2020 年に店舗をリニューアルオープン。「大人が楽しめるカフェ」というコンセプトで、青を基調としたスタイリッシュな空間にもかかわらず、温かみのある店内がミカサデコ＆カフェの魅力です。`}</p>
    <h3>{`遅めのランチだと行列に`}</h3>
    <p>{`ミカサデコのパンケーキ人気なのは、「踊るパンケーキ」と言われるほど、ふわふわなパンケーキが理由です。そのパンケーキを求めて、ランチ終わりの時間帯である 13 時以降は行列ができることもしばしば。行列を避けてランチを食べたい方は、11〜12 時前の時間帯が狙い目なので、行く際は行列に巻き込まれないように注意してください…！`}</p>
    <h3>{`リコッタチーズパンケーキ`}</h3>
    <InstaImage postId="B9lO1VDngUi" mdxType="InstaImage" />
    <p>{`ミカサデコカフェ 1 番の人気のメニューが一こちらのリコッタチーズパンケーキです！`}</p>
    <p>{`このパンケーキを求めて連日行列ができ、ブランチとして甘いパンケーキを食べる方も多いそう。`}</p>
    <p>{`玄米カレーなどのランチメニューを頼んだあとに、ペアで 1 つのリコッタチーズパンケーキを食べるのもいいですよね。`}</p>
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="breespi23akg00eoptr0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿のパンケーキランチのお店をご紹介しましたがいかがでしたでしょうか。甘いパンケーキだけでなく、食事系のパンケーキも取り揃えており、その日の気分に合わせてランチとして食べられるのは嬉しいですよね。いつも行列がができる人気店ですが、時間帯によっては行列を避けることもできるので、行列情報をチェックしてお店にお越しください。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;